import Vue from 'vue';
import get from 'lodash/get';
import { NotificationProgrammatic, ToastProgrammatic, DialogProgrammatic } from 'buefy';
import ErrorMessages from '@shared/messages/errors.json';

export default ({
  router, store, i18n, loginRoute,
}) => {
  const errorHandlers = {
    axios(error) {
      console.log('axios', { ...error });

      if (!error.isAxiosError) {
        errorHandlers.default(error);
        return Promise.resolve();
      }

      const status = get(error, 'response.status', null);

      if (status === 422) {
        errorHandlers.apiValidationErrors(error);
      } else if (status === 401) {
        NotificationProgrammatic.open({
          message: get(error, 'response.data.message', i18n.t('errors.status.401') || ErrorMessages[401]),
          type: 'is-danger',
          position: 'is-top',
        });
        return router.push(loginRoute);
      } else if ([307, 503].includes(status)) {
        NotificationProgrammatic.open({
          message: get(error, 'response.data.message', i18n.t('errors.status.307') || ErrorMessages[307]),
          type: 'is-danger',
          position: 'is-top',
        });
      } else if ([409, 500].includes(status)) {
        NotificationProgrammatic.open({
          message: get(error, 'response.data.message', i18n.t(`errors.status.${status}`) || ErrorMessages[status]),
          type: 'is-danger',
          position: 'is-top',
        });
      } else if (![null, undefined].includes(status)) {
        NotificationProgrammatic.open({
          message: get(error, 'response.data.message', ErrorMessages[500]),
          type: 'is-danger',
          position: 'is-top',
        });
      } else {
        errorHandlers.stack(error);
      }

      return Promise.resolve();
    },
    apiValidationErrors(error) {
      const { errors } = error.response.data;
      errorHandlers.default({
        message: Object.keys(errors).map((field) => errors[field].join(', ')).join(', '),
      });
    },
    default(error) {
      if (error._isRouter || error.name === 'NavigationDuplicated') {
        return;
      }

      if (error.name === 'PrivacyError') {
        return;
      }

      const message = (error && error.message) || error;

      NotificationProgrammatic.open({
        message: typeof message !== 'string' ? message : (ErrorMessages[message] || message),
        type: 'is-danger',
        position: 'is-top',
      });
    },
    stack(error) {
      console.log('stack');
      console.error(error);
    },
    showPage(code, message) {
      console.log(code, message);
      store.commit('errors/setError', { code, message });
    },
    showNetworkErrorDialog() {
      DialogProgrammatic.alert({
        type: 'is-danger',
        message: i18n.t('errors.network.message'),
        confirmText: i18n.t('errors.network.refresh'),
        onConfirm() {
          window.location.reload();
        },
      });
    },
  };

  router.afterEach(() => {
    store.state.errors.code && store.commit('errors/setError', {
      code: null,
      message: '',
    });
  });

  window.addEventListener('unhandledrejection', (event) => {
    event.preventDefault();
    const detail = event.detail || event;
    console.log('unhandledrejection', { ...detail });
    const error = detail.reason || detail;
    errorHandlers.axios(error);
  });

  Vue.config.errorHandler = (error) => {
    console.log('errorHandler');
    errorHandlers.stack(error);
  };

  Vue.prototype.$showMessage = {
    sent() {
      ToastProgrammatic.open({
        message: i18n.t('errors.notifications.sent'),
        type: 'is-success',
      });
    },
    success() {
      ToastProgrammatic.open({
        message: i18n.t('errors.notifications.saved'),
        type: 'is-success',
      });
    },
    error(message) {
      NotificationProgrammatic.open({
        message,
        type: 'is-danger',
        position: 'is-top',
      });
    },
    goPro(onConfirm, onCancel, options = { plan: 'PRO' }) {
      const storePlan = i18n.t(`packs.${store.getters['auth/store'].plan}`);
      DialogProgrammatic.confirm({
        message: `
          <div class="content">
            <p>${i18n.t('errors.notifications.upgrade.message', { plan: storePlan })}</p>
            <p>${i18n.t('errors.notifications.upgrade.upgrade_message', { targetPlan: i18n.t(`packs.${options.plan}`) })}</p>
          </div>
        `,
        type: 'is-warning',
        hasIcon: true,
        icon: 'gem',
        confirmText: i18n.t('errors.notifications.upgrade.confirm'),
        onConfirm: onConfirm || (() => {
          router.push({ name: 'plan', query: { onglet: 'vous' } });
        }),
        onCancel: onCancel || undefined,
      });
    },
  };

  Vue.prototype.$errorHandlers = errorHandlers;

  return errorHandlers;
};
